<template>
<div class="container push-up">
  <div class="row">
    <div class="columns small-12 medium-10 large-8">
        <h1 
          data-test="exception-error-page-title"
          id="error-page-title"
          class="push-down"
          v-html="model.MessageTitle"
        />
        <div data-test="exception-error-page-text" v-html="model.MessageText" />

      <div class="push-up">
        <h2 data-test="exception-error-page-technical-details-title">
          {{ model.TechnicalDetailsTitle }}
        </h2>
        <ul data-test="exception-error-page-technical-details">
          <li>{{ model.ExceptionIdText }} {{ model.ExceptionId }}</li>
          <li>{{ model.ExceptionCodeText }} {{ model.ExceptionCode }}</li>
          <li>{{ model.ExceptionTimeText }} {{ getFormattedErrorDate }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Utility from '@/common/UtilityFunctions';

export default {
  name: 'ErrorPage',
  props: {
    model: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      errorDate: this.model.DateTime,
    };
  },
  computed: {
    getFormattedErrorDate() {
      const errorDate = Utility.formatDateString(this.errorDate);
      const errorTime = new Date(this.errorDate).toLocaleTimeString('da-DK');

      return `${errorDate} ${errorTime}`;
    }
  }
};
</script>
